/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * DEBUG-ONLY Feature Override surface. Grouped under `src/devtools` alongside
 * the app-version and mock overrides; everything is gated by
 * `isDevToolsBuild()` and inert in release builds.
 *
 * Two independent concerns live here, in two `localStorage` keys:
 *   - **Activation overrides** — force a feature ON/OFF (highest priority).
 *   - **Stage overrides**      — evaluate a feature at a different lifecycle
 *                                stage, leaving the rest of the decision intact.
 */

export { FeatureOverrideProvider } from "./FeatureOverrideProvider";
export {
  FEATURE_OVERRIDE_STORAGE_KEY,
  clearAllFeatureOverrides,
  clearFeatureOverride,
  getFeatureOverride,
  readFeatureOverrides,
  setFeatureOverride
} from "./featureOverrideStorage";
export { FeatureStageOverrideProvider } from "./FeatureStageOverrideProvider";
export {
  FEATURE_STAGE_OVERRIDE_STORAGE_KEY,
  clearAllFeatureStageOverrides,
  clearFeatureStageOverride,
  getFeatureStageOverride,
  readFeatureStageOverrides,
  setFeatureStageOverride
} from "./featureStageOverrideStorage";
